import { AppStateMachineContext } from '../types';

export const switchProductsCoverageDetails = (context: AppStateMachineContext): AppStateMachineContext => {
  const { businessProductCode } = context.rateData;

  if (!businessProductCode) {
    return context;
  }

  const coveragesDetails = context.initialProductsCoverageDetails?.[businessProductCode];

  return {
    ...context,
    ...(coveragesDetails && { coveragesDetails }),
  };
};
